import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiInformal: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_17026)">
                <path
                    d="M2.46178 4.61402C2.89424 3.67018 4.0418 3.27531 4.98452 3.69341C5.08185 3.73659 5.12578 3.85051 5.0826 3.94784C5.05083 4.01946 4.9808 4.06215 4.90724 4.06254C4.41378 4.06254 3.93516 4.09292 3.4888 4.32369C3.21462 4.46543 2.9976 4.66415 2.7537 4.84736C2.66914 4.9119 2.54829 4.89566 2.48375 4.8111C2.43911 4.75264 2.43326 4.67659 2.46178 4.61402Z"
                    fill="#A1D167"
                />
                <path
                    d="M4.31025 6.85737C4.73508 6.85737 5.07948 6.45558 5.07948 5.95994C5.07948 5.4643 4.73508 5.0625 4.31025 5.0625C3.88541 5.0625 3.54102 5.4643 3.54102 5.95994C3.54102 6.45558 3.88541 6.85737 4.31025 6.85737Z"
                    fill="#A1D167"
                />
                <path
                    d="M9.41915 4.91134C8.3709 4.60727 7.45138 5.12083 6.8871 5.98268C6.86941 6.00996 6.85513 6.04158 6.84684 6.07488C6.80677 6.23614 6.905 6.39934 7.06623 6.43942L7.06772 6.43978C7.72477 6.60311 8.39269 6.75147 9.06449 6.83932C9.14895 6.85037 9.23351 6.80345 9.26638 6.72065C9.30523 6.62281 9.25741 6.51199 9.15956 6.47314C8.6689 6.27829 8.16202 6.12273 7.65574 5.97427C8.09207 5.46527 8.71077 5.27616 9.36531 5.28514C9.44831 5.2855 9.5249 5.23122 9.54915 5.14755C9.57846 5.04645 9.52028 4.94068 9.41915 4.91134Z"
                    fill="#A1D167"
                />
                <path
                    d="M6.73117 4.27081C7.24427 3.36827 8.42183 3.07486 9.32455 3.57355C9.41776 3.62504 9.45158 3.74235 9.40009 3.83558C9.36222 3.90414 9.28871 3.94058 9.2154 3.93455C8.72383 3.89155 8.24437 3.88011 7.7796 4.07109C7.49412 4.1884 7.2606 4.36745 7.00165 4.5287C6.91181 4.58563 6.79281 4.55891 6.73589 4.46906C6.69653 4.40691 6.69732 4.33065 6.73117 4.27081Z"
                    fill="#A1D167"
                />
                <path
                    d="M4.7097 8.41516C4.87575 8.62993 5.06847 8.80029 5.2898 8.91324C5.50975 9.02698 5.75455 9.0849 6.00001 9.08503C6.24547 9.08426 6.49003 9.02644 6.70991 8.9127C6.93103 8.79967 7.12378 8.62967 7.29032 8.41516L7.29462 8.4096C7.36062 8.3246 7.48303 8.30919 7.56806 8.37519C7.63562 8.42762 7.65906 8.51601 7.63278 8.59262C7.52314 8.9107 7.29703 9.20052 7.00344 9.39736C6.71026 9.59547 6.35462 9.70096 6.00001 9.70029C5.64542 9.70034 5.29001 9.5949 4.99691 9.39685C4.7035 9.19993 4.47739 8.91047 4.36724 8.59265C4.33201 8.49098 4.38585 8.38001 4.48752 8.34478C4.56855 8.3167 4.6555 8.34521 4.70529 8.40942L4.7097 8.41516Z"
                    fill="#A1D167"
                />
                <path
                    d="M10.2426 1.75736C9.10939 0.624103 7.60267 0 6 0C2.72931 0 0 2.72931 0 6C0 9.27069 2.72931 12 6 12C9.27069 12 12 9.27069 12 6C12 4.39733 11.3759 2.89062 10.2426 1.75736ZM6 11.5385C3.04133 11.5385 0.563308 9.12597 0.563308 6.15272C0.563308 3.15492 3.00221 0.716026 6 0.716026C8.9978 0.716026 11.4367 3.15492 11.4367 6.15272C11.4367 9.12592 8.95867 11.5385 6 11.5385Z"
                    fill="#A1D167"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_17026">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiInformal;
